function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#596168",
  fillRule: "evenodd",
  d: "M5 4.371L1.56.501a.75.75 0 10-1.12.997l4 4.5a.75.75 0 001.12 0l4-4.5A.75.75 0 108.44.502L5 4.372z"
});

var SvgCaret = function SvgCaret(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7"
  }, props), _ref);
};

export default SvgCaret;